import React, { useState, useEffect } from 'react';
import { Paper, Box, Grid , Chip, Typography, MenuItem , TextField ,  CircularProgress } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from "moment";
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import Modal from 'react-bootstrap/Modal';
import MyTable from '../../components/Schedule/MyTable';
import { toast } from 'react-toastify';
import { Col, Row } from 'react-bootstrap';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const VacationBidsUser = () => {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [bidsData , setBidsData] = useState([]);
    const [date, setDate] = useState();
    const [shifts , setShifts] = useState([]);
    const [selectedShifts , setSelectedShifts] = useState('');
    const [selectedData , setSelectedData] = useState([]);

    const columns = [
        { 
            field: 'Start_Date', 
            headerName: 'Start Date', 
            minWidth : 180,
            valueGetter: (params) => moment(params.row.Start_Date).format('MM/DD/YYYY'),
        },
        { 
            field: 'End_Date', 
            headerName: 'End Date', 
            minWidth : 180,
            valueGetter: (params) => moment(params.row.End_Date).format('MM/DD/YYYY'),
        },
        {
            field: 'Group_Code', headerName: 'Group Code', flex: 1, maxWidth : 170,
            renderCell: (params) => {
                return (
                    <Chip
                        sx={{
                            backgroundColor: '#0d6efd',
                            color: '#ffffff',
                            cursor: 'pointer',
                            width: '40px'
                        }}
                        label={params.row.Group_Code}
                    />  
                );
            }
        },
        {
            field: 'status', headerName: 'Status', flex: 1, maxWidth : 180,
            renderCell: (params) => {
                return (
                    <Chip
                        sx={{
                            backgroundColor: params.row.members[0].Status == "approved" ? '#008000' :  '#000000',
                            color: '#ffffff',
                            cursor: 'pointer',
                            width: '100px'
                        }}
                        label={params.row.members[0].Status}
                    />  
                );
            }
        },
        {
            field: 'actions', headerName: 'Actions', flex: 1, minWidth : 140,
            renderCell: (params) => {
                return (
                    <ButtonTheme variant="filled" color='primary' className='rounded-2' disabled = {params.row.is_show == false}
                        onClick={() => {
                            setShowModal(true)
                            setSelectedData(params?.row)
                        }}>
                        Vacation Bid
                    </ButtonTheme>
                );
            }
        },
    ];

    const getMyBids = (loader = true) => {
        if (loader) {
            setLoading(true)
        }
        ApiService.get('/getMyBids')
            .then(({ data }) => {
                setBidsData(data?.data || [])
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                toast.error(e?.response?.data?.message || "error")
            })
    }

    useEffect(()=>{
        getMyBids()
    }, [])

    const ShiftsData = () =>{
        ApiService.get('/shiftTypes').then(({ data }) => {
            setShifts(data?.data || [])
            }).catch(() => {
              toast.error("Error")
            })
    }

    useEffect(()=>{
        ShiftsData()
    }, [])


    const postVacBid = () => {
        const body = {
            "vacation_bid_id": selectedData?.members[0].Vacation_Bid_Id, 
            "shift_date": moment(date).format('YYYY-MM-DD'),
            "shift_code": selectedShifts
        }
        ApiService.post('/vacationBid/request-pick', body)
            .then(( data ) => {
                toast.success(data?.message)
                setShowModal(false)
                setSelectedData([])
                setSelectedShifts("")
                setDate("")
                getMyBids()
                setLoading(false);
            })
            .catch(( error ) => {
                toast.error(error?.data?.message || error?.data  || "error");
                setLoading(false);
            })
    }


    return (
        <>
            {loading ? (
                <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
                    <CircularProgress />
                </Paper>
            )
                :
                (
                    <>
                        <Paper className="p-4 font-fam" style={{ marginTop: "1rem", minHeight: '98%' }}>
                            <Grid container className='align-items-center' gap={2} style={{ gap: "24px", marginTop: "7px" }} >
                                <Grid item xs={10} md={4}>
                                    <Typography variant="h5">My Vacation Bids</Typography>
                                </Grid>
                            </Grid>

                            <div>
                                {(bidsData?.length === 0) ?
                                    <Box>
                                        <div className='inner-box d-flex flex-column align-items-center justify-content-center' style={{ height: 530 }}>
                                            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                                            <div className='mt-2' style={{ color: '#555555' }}>
                                                Empty Vacation Bids
                                            </div>
                                        </div>
                                    </Box>
                                :
                                    <>
                                        <div className='mt-3'>
                                            <MyTable
                                                rows={bidsData}
                                                columns={columns}
                                                rowCount={bidsData.length}
                                                checkboxSelection={false}
                                                hideFooter={bidsData.length > 100 ? false : true}
                                            />
                                        </div>
                                    </>
                                }
                            </div>

                        </Paper >
                    </>
                )}

            <div className='font-fam'>
                <Modal show={showModal} size="md"
                    onHide={() => {
                        setShowModal(false)
                        setSelectedShifts("")
                        setSelectedData([])
                        setDate("")
                    }}>

                    <Modal.Header closeButton>
                        <Modal.Title>Request Vacation Bid</Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{ padding: 22 }}>
                       <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={12}>
                                <label style={{ fontSize: '14px' }}>Date</label>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        value={date}
                                        onChange={(e) => setDate(e)}
                                        sx={{
                                        width: "100%",
                                            "& .MuiInputBase-root": {
                                                height: '48px',
                                                fontSize: '14px'
                                            },
                                        }}
                                        // disablePast
                                        dateInputIcon={<CalendarTodayIcon />}
                                />
                                </LocalizationProvider>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                                <label style={{ fontSize: '14px' }}>Shifts</label>
                                <TextField
                                    className='w-100' color='secondary' variant="outlined"
                                    select
                                    value={selectedShifts}
                                    onChange={e => setSelectedShifts(e.target.value)}
                                    placeholder='Please select'
                                    InputProps={{
                                        sx: {
                                        height: '48px',
                                        fontSize: '14px'
                                        }
                                    }}
                                >
                                    {shifts.map(type => (
                                        <MenuItem value={type.ShiftCode}>{type.Short_Desc} </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
        
                        </Grid>

                        <Row>
                            <Col md='auto'>
                                <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
                                        setShowModal(false)
                                        setSelectedShifts("")
                                        setSelectedData([])
                                        setDate("")
                                    }}>
                                    Cancel
                                </ButtonTheme>
                            </Col>
                            <Col md='auto'>
                                <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={postVacBid}>
                                    Save
                                </ButtonTheme>
                            </Col>
                        </Row>

                    </Modal.Body>
                </Modal>
            </div>
        </>
    )
}
export default VacationBidsUser;
